exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item_wrap .input_wrapper[data-v-b957a324]{margin-left:0}.img_wrap[data-v-b957a324]{margin:10px 0}\n", ""]);

// exports
